import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { BarChart3, Menu, Percent } from 'lucide-react';
import Sidebar from '@/components/common/Sidebar';
import TrialBanner from '@/components/common/TrialBanner';
import CommissionRulesList from '@/components/commission/CommissionRulesList';
import { useUIStore } from '@/store/uiStore';
import { authApi } from '@/services/api';

export default function CommissionPage() {
  const { t } = useTranslation();
  const { toggleSidebar } = useUIStore();

  const { data: profile } = useQuery({
    queryKey: ['companyProfile'],
    queryFn: async () => {
      const res = await authApi.getCompanyProfile();
      return res.data.message;
    },
  });

  const commissionEnabled = !!profile?.enable_commission;

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <TrialBanner />
        <div className="p-6">
          <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
            <div className="flex items-center gap-3">
              <button
                onClick={toggleSidebar}
                className="lg:hidden p-2 -ml-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg shrink-0"
              >
                <Menu className="w-5 h-5" />
              </button>
              <div>
                <h1 className="text-2xl font-bold text-gray-900 flex items-center gap-2">
                  <Percent className="w-7 h-7 text-primary-600" />
                  {t('commission.title')}
                </h1>
                <p className="text-gray-500 text-sm">{t('commission.subtitle')}</p>
              </div>
            </div>

            <Link
              to="/reports/sales/commission"
              className="btn-secondary inline-flex items-center gap-2 text-sm"
            >
              <BarChart3 className="w-4 h-4" />
              {t('commission.viewReport')}
            </Link>
          </div>

          {!commissionEnabled && (
            <div className="mb-6 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
              {t('commission.disabledBanner')}{' '}
              <Link to="/settings?tab=pos_rules" className="font-medium underline">
                {t('commission.disabledBannerSettings')}
              </Link>{' '}
              {t('commission.disabledBannerSuffix')}
            </div>
          )}

          <div className="card p-6">
            <CommissionRulesList />
          </div>
        </div>
      </div>
    </div>
  );
}
